import { PointDetailScreen } from "@/src/screens/point-detail-screen";

export default function PointDetailRoute() {
  return <PointDetailScreen />;
}
